import React, { useState } from "react";
import { DatePicker, Button } from "antd";
import MonthlyIcon from "../../images/icons/Monthly.png";
import dayjs from "dayjs";
import "./CustomDatePicker.css";
import locale from "antd/es/date-picker/locale/en_US";

const customLocale = {
  ...locale,
  lang: {
    ...locale.lang,
    shortWeekDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  },
};

const CustomDatePicker = (props) => {
  const [value, setValue] = useState(null);
  const [open, setOpen] = useState(false);

  const fromDay = props?.item?.text_data?.from_day;
  const toDay = props?.item?.text_data?.to_day;

  const disabledDate = (current) => {
    if (!current) return false;
    
    const today = dayjs().startOf('day');
    const startDate = fromDay === "0" ? today : dayjs(fromDay, "DD/MM/YYYY").startOf('day');
    const endDate = toDay ? dayjs(toDay, "DD/MM/YYYY").endOf('day') : null;
    
    if (endDate) {
      return current < startDate || current > endDate;
    }
    return current < startDate;
  };

  const handleChange = (date) => {
    console.log('Date changed:', date);
    setValue(date);
    const formattedValue = date ? date.format("YYYY-MM-DD") : null;
    
    if (formattedValue) {
      props?.inputValue?.current?.removeAttribute("disabled");
    } else {
      props?.inputValue?.current?.setAttribute("disabled", true);
    }

    localStorage.setItem("inputValue", JSON.stringify({ key1: formattedValue }));
  };

  const handleSelectClick = () => {
    if (value) {
      const formattedValue = value.format("YYYY-MM-DD");
      if (formattedValue) {
        props?.inputValue?.current?.removeAttribute("disabled");
      }
      localStorage.setItem("inputValue", JSON.stringify({ key1: formattedValue }));
    }
    setOpen(false);
  };

  return (
    <DatePicker
      open={open}
      value={value}
      onChange={handleChange}
      onOpenChange={setOpen}
      format="DD / MM / YY"
      placeholder="DD / MM / YY"
      allowClear={false}
      showToday={false}
      locale={customLocale}
      disabledDate={disabledDate}
      inputReadOnly
      placement="bottomCenter"
      suffixIcon={<img src={MonthlyIcon} alt="calendar" style={{ width: "22px", height: "22px" }} />}
      className="custom-datepicker-input action-tab"
      popupClassName="custom-datepicker-popup"
    //   renderExtraFooter={() => (
    //     <div className="datepicker-footer">
    //       <Button
    //         type="link"
    //         className="datepicker-select-btn"
    //         onClick={handleSelectClick}
    //       >
    //         Select
    //       </Button>
    //     </div>
    //   )}
    />
  );
};

export default CustomDatePicker;
